import { ReportedHoursGroupBy, ReportedHoursVisibleColumnName } from "./types"

type ReportedHoursGroupByOptions = {
  availableColumns: ReportedHoursVisibleColumnName[]
}

const groupByRequiredColumns: Partial<Record<ReportedHoursGroupBy, ReportedHoursVisibleColumnName>> = {
  [ReportedHoursGroupBy.WORKER]: "worker",
  [ReportedHoursGroupBy.PROJECT]: "projectOrTask",
  [ReportedHoursGroupBy.CUSTOMER]: "customer",
  [ReportedHoursGroupBy.STATUS]: "status",
}

export const getReportedHoursGroupByOptions = ({
  availableColumns,
}: ReportedHoursGroupByOptions): ReportedHoursGroupBy[] => [
  ReportedHoursGroupBy.NO_GROUPING,
  ...Object.values(ReportedHoursGroupBy).filter((groupBy) => {
    const requiredColumn = groupByRequiredColumns[groupBy]
    return requiredColumn ? availableColumns.includes(requiredColumn) : false
  }),
]

export const mapReportedHoursGroupByValue = (
  groupByValue: string,
  options: ReportedHoursGroupByOptions
): ReportedHoursGroupBy => {
  return getReportedHoursGroupByOptions(options).find((option) => option === groupByValue)
    ? (groupByValue as ReportedHoursGroupBy)
    : ReportedHoursGroupBy.NO_GROUPING
}
